import { Controller } from "@hotwired/stimulus"

// Fires a Google Analytics (gtag) event on click. Usage:
//   data-controller="analytics" data-action="click->analytics#track"
//   data-analytics-event-value="cta_click" data-analytics-props-value='{"location":"hero"}'
export default class extends Controller {
  static values = { event: String, props: Object }

  track() {
    if (typeof gtag === "function") {
      gtag("event", this.eventValue, this.propsValue)
    }
  }
}
